<template>
    <div style="clear:both;">
      <select class="select" v-model="selected" style="font-size: 10pt;">
        <option v-for="(option, index) in formElement.dynamicTypeData.options" v-bind:value="option" v-bind:key="index">
          {{ option }}
        </option>
      </select>
      <p class="error" v-if="formElement.dynamicTypeData.isValid !== undefined && !formElement.dynamicTypeData.isValid" v-html="formElement.dynamicTypeData.errorText" />
  </div>
</template>

<script>
export default {
  name: "kollecto-select",
  props: ["formElement", "userAction"],
  computed: {
    selected: {
      get: function() {
        if (this.userAction === "create" || !this.userAction) {
          if (this.formElement.dynamicTypeData.defaultSelectedIndex) {
            return this.formElement.dynamicTypeData.options[
              this.formElement.dynamicTypeData.defaultSelectedIndex
            ];
          } else {
            return this.formElement.dynamicTypeData.options[
              this.formElement.dynamicTypeData.selectedIndex
            ];
          }
        } else {
          return this.formElement.dynamicTypeData.options[
            this.formElement.dynamicTypeData.selectedIndex
          ];
        }
      },
      set: function(value) {
        const vm = this;
        this.formElement.dynamicTypeData.options.forEach(function (option, idx) {
          if (option === value) {
            vm.formElement.dynamicTypeData.selectedIndex = idx;
          }
        })
      }
    }
  }
};
</script>
